import { useEffect, useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined, SettingOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import Tab4 from './Tab1';
import Tab2 from './Tab2';
import OperationsLiees from './OperationsLiees';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import { OpeApi } from "../../../Services/ApiOpeLiees";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/Operat';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import CheckStan from "../../Prints/CheckStan";
import { useNavigate } from "react-router-dom";
import VerifDay from "../../../Functions/Traitement/VerifDay";
import { Padding } from "@mui/icons-material";


//pour la table Operation
let searchOperat: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

//pour les Messages publicitaire
let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

//pour les Comptes
let searchComptes: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }

//pour les numcli
let searchNumcli: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }

let searchFormatSms: ParamsPicklist = { CodeAgence: '', Table: 'FormatSms', Colonne1: 'codSmS', Colonne2: 'descriptionSMS', Colagence: '101', Choix: 22 };

//pour les grilles de tarification (vue : 1 ligne par grille)
let searchTarif: ParamsPicklist = { CodeAgence: '', Table: 'V_TARIFICATION_GRILLES', Colonne1: 'CODTARIF', Colonne2: 'LIBELLE_GRILLE', Colagence: '101', Choix: 22 };



const Operation = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Idbutton, setIdbutton] = useState(false);
    const [Liblibelle, setLiblibelle] = useState(true);
    const [Load, SetLoad] = useState(false);
    const Navigate = useNavigate();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))



    const dataOption2: DataSelect[] = [
        { label: "Caisse Principal", value: "P" },
        { label: "Caisse Secondaire", value: "S" }
    ]

    useEffect(() => {

        if (Load === false) {
            VerifDay(user.coduti, user.codage, authHeader, Navigate);
            SetLoad(true);
        }
    }, []);

    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false)
        setIdbutton(true)
        setLiblibelle(true)
    }

    function HandleAjout() {
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add')
        setIdbutton(false)
        setLiblibelle(false)
    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
        setIdbutton(true)
        setLiblibelle(false)
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
        setIdbutton(false);
        setLiblibelle(true);
    }



    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Création Opération
                </span>
            ),
            children: <>
                <div className='tabItem' style={{ width: '102%' }} >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                            <legend> Mise en place Operation </legend>

                            <Box style={{ width: '100%', marginTop: -15 }}>
                                <fieldset className="bordure1" style={{ display: 'flex' }}>
                                    <Box style={{ marginLeft: 30, width: '50%', marginTop: -5 }}>
                                        <SearInputG width={0} dissabledLib={Liblibelle} dissabledCode={Idbutton} notremove Titre=" Recherche" label='Code' name="CODOPE" Taille1={'100%'} Taille2={'100%'} Parametre={searchOperat} form={form} />
                                    </Box>
                                    <Box style={{ marginLeft: 30, width: '50%', marginTop: -5 }}>
                                        <SearchModal width={0} Titre="" notRequired label="Idplan Contre-Partie" name="IDPLAN" Parametre={searchPlancp} Taille1={'100%'} Taille2={'100%'} form={form} />
                                    </Box>
                                </fieldset>
                            </Box>
                            <Box style={{ marginTop: 0 }}>
                                <Box style={{ display: 'flex', width: '100%' }}>
                                    <Box style={{ width: '30%' }}>
                                        <Box style={{ marginTop: 0 }}>
                                            <fieldset className="bordure1" style={{}}>
                                                <Box style={{ marginLeft: 10 }} >
                                                    <CheckStan width={20} label={"Modifier Libellé Opération"} name={"MODLIB"} />
                                                </Box>
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Modifier Date Opération"} name={"MODDAO"} />
                                                </Box>
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Commission Compte"} name={"COMMIS"} />
                                                </Box>
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Activer Compte Dormant"} name={"ACTIVE"} />
                                                </Box>
                                                {/* <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Compte Bénéficiaire"} name={"isbloqCai"} />
                                                </Box> */}
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Création Numéro Compte"} name={"CRECPT"} />
                                                </Box>
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Statistique Opération"} name={"STAOPE"} />
                                                </Box>
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Avis de l'Opération"} name={"AVIOPE"} />
                                                </Box>
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Modifier Date Valeur"} name={"MODDAV"} />
                                                </Box>
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Saisir Billetage"} name={"BILLET"} />
                                                </Box>
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Recevoir Découvert"} name={"DECOUV"} />
                                                </Box>
                                                <Box style={{ marginLeft: 10, marginTop: -30 }}>
                                                    <CheckStan width={20} label={"Modifier Montant Commission"} name={"MODCON"} />
                                                </Box>

                                                <Box style={{ height: "50px", marginLeft: 10, marginTop: -30, backgroundColor: "rgba(255, 0, 0, 0.1)", border: "2px red dashed", padding: "5px", borderRadius: "10px" }}>
                                                    <CheckStan width={20} label={"Est une opération système"} name={"ISSYSTEM"} />
                                                </Box>
                                            </fieldset>
                                        </Box>
                                    </Box>
                                    <Box style={{ width: '70%' }}>
                                        <Box style={{ marginLeft: 5 }}>
                                            <fieldset className="bordure1" style={{}}>
                                                <Box style={{ display: 'flex', width: '100%' }}>
                                                    <Box style={{ width: '50%' }}>
                                                        <Box style={{ marginTop: 0, width: '100%' }}>
                                                            <InputForm width={13} label="Nombre de jours Débit" type="number" name="NBRJOURD" />
                                                        </Box>
                                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                                            <InputForm width={13} label="Nombre de jour Crédit" type="number" name="NBRJOURC" />
                                                        </Box>
                                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                                            <InputForm width={13} label="Niveau Minimal" type="number" name="NIVMIN" />
                                                        </Box>
                                                    </Box>
                                                    <Box style={{ width: '50%' }}>
                                                        <Box style={{ marginTop: 0, width: '100%' }}>
                                                            <InputForm width={13} label="Montant Maximal" type="number" name="MONMAX" />
                                                        </Box>
                                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                                            <InputForm width={13} label="Pourcentage" type="number" name="POURCE" />
                                                        </Box>
                                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                                            <InputForm width={13} label="Montant Fixe" type="number" name="MONFIX" />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </fieldset>
                                        </Box>
                                        <Box style={{ marginLeft: 5, marginTop: 5 }}>
                                            <fieldset className="bordure1" style={{}}>
                                                <Box style={{ width: '100%' }}>
                                                    <SearchModal width={5} Titre="" notRequired label="Message Publicitaire" name="OPEMSG" Taille1={'100%'} Parametre={searchOperat} Taille2={'150%'} form={form} />
                                                </Box>
                                                <Box style={{ width: '100%', marginTop: -10 }}>
                                                    <SearchModal width={5} Titre="" notRequired label="Code Plage" name="cdplag" Taille1={'100%'} Parametre={searchOperat} Taille2={'150%'} form={form} />
                                                </Box>
                                                <Box style={{ width: '100%', marginTop: -10 }}>
                                                    <SearchModal width={5} Titre="Recherche du format SMS" notRequired label="Format d'SMS associé" name="CODFORMATSMS" Taille1={'100%'} Parametre={searchFormatSms} Taille2={'150%'} form={form} />
                                                </Box>
                                                <Box style={{ width: '100%', marginTop: -10 }}>
                                                    <SearchModal width={5} Titre="Recherche de la grille tarifaire" notRequired label="Grille tarifaire" name="CODTARIF" Taille1={'100%'} Parametre={searchTarif} Taille2={'150%'} form={form} />
                                                </Box>
                                            </fieldset>
                                        </Box>
                                        <Box style={{ marginLeft: 5, marginTop: 5 }}>
                                            <fieldset className="bordure1" style={{}}>
                                                <OperationsLiees form={form} disabled={FormAct} authHeader={authHeader} />
                                            </fieldset>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </div>
                </div >
            </>,
        },
        {
            key: '2',
            label: (
                <span id='x'>
                    <SettingOutlined />
                    Gestion des Conditions
                </span>
            ),
            children: <Tab2 />,
        }
    ];

    // function consult 
    function consult() {
        if (form.getFieldValue("CODOPE") == null) {
            SweetAlert.fire({ title: "Svp renseigner le Code Operation", icon: "warning" });
        } else {
            HandleConsult()
            let data = (form.getFieldValue("CODOPE"));

            if (data.length != 0) {
                setLoading(true)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadOperat,
                    headers: {
                        'CypherOperat': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            //const res = JSON.parse(Crypter.decrypt(response.data));
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let DemandVP = res.Result.Table[0]
                            console.log(DemandVP);

                            if (res.StatutCode == 200) {

                                if (DemandVP.messag == "Inexiste") {
                                    HandleAnnul()
                                    SweetAlert.fire({ title: "", text: "Code Operation Inexistant", icon: "warning" })

                                } else {
                                    form.setFieldsValue(DemandVP);
                                    // Fallback legacy : OPEREL1-5 si la chaine OPERATLIEE est vide
                                    const opsLiees = ["OPEREL1", "OPEREL2", "OPEREL3", "OPEREL4", "OPEREL5"]
                                        .filter((k) => DemandVP[k])
                                        .map((k) => ({ CODELIE: DemandVP[k], LIBELIE: "", GROUPE_ID: null, BASE_CALCUL: "PRECEDENT" }));
                                    loadChaine(DemandVP.CODOPE, opsLiees);
                                }

                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }

    // Charge la chaine OPERATLIEE (source de verite du moteur) ; fallback OPEREL1-5
    const loadChaine = (codope: string, fallback: any[]) => {
        axios.request({
            method: 'get',
            maxBodyLength: Infinity,
            url: OpeApi.ReadChaine,
            headers: { 'CODOPE': codope, 'Authorization': authHeader(), 'Content-Type': 'application/json' }
        }).then((response) => {
            const res = response.data ? JSON.parse(Crypter.decrypt(response.data)) : null;
            const rows = res?.Result?.Table ?? [];
            form.setFieldValue("OPERELIES",
                res?.StatutCode === 200 && rows.length > 0
                    ? rows.map((r: any) => ({
                        CODELIE: r.CODOPEREL,
                        LIBELIE: r.LIBELIE ?? "",
                        GROUPE_ID: r.GROUPE_ID ?? null,
                        GROUPE_LIB: r.CODGRP ? `${r.CODGRP} — ${r.LIBGRP}` : null,
                        BASE_CALCUL: r.BASE_CALCUL ?? "PRECEDENT"
                    }))
                    : fallback
            );
        }).catch(() => form.setFieldValue("OPERELIES", fallback));
    };

    // Sauvegarde atomique de la chaine apres succes du CRUD OPERAT
    const saveChaine = (codope: string) => {
        const chaine = {
            CODOPE: codope,
            UTILIS: Perss.coduti,
            LIEES: (form.getFieldValue("OPERELIES") ?? [])
                .filter((l: any) => l?.CODELIE)
                .map((l: any, i: number) => ({
                    CODOPEREL: l.CODELIE,
                    ORDREEXEC: i + 1,
                    GROUPE_ID: l.GROUPE_ID ?? null,
                    BASE_CALCUL: l.BASE_CALCUL ?? "PRECEDENT",
                    ACTIVE: true
                }))
        };
        const data = Crypter.encrypt(JSON.stringify(chaine));
        axios.request({
            method: 'post',
            maxBodyLength: Infinity,
            url: OpeApi.SaveChaine,
            headers: { 'CypherChaine': data, 'Authorization': authHeader(), 'Content-Type': 'application/json' }
        }).then((response) => {
            const res = response.data ? JSON.parse(Crypter.decrypt(response.data)) : null;
            if (res?.StatutCode !== 200) {
                SweetAlert.fire({ title: "Operation enregistree", text: "Chaine refusee : " + (res?.Message ?? "erreur"), icon: "warning" });
            }
        }).catch((error) => {
            SweetAlert.fire({ title: "Operation enregistree", text: "Chaine non enregistree : " + error, icon: "warning" });
        });
    };

    // function Onfinish
    const onFinish = (values: any) => {

        console.log(values)
        var Demand: Demand = values
        const codesLiees: string[] = (values.OPERELIES ?? [])
            .map((o: any) => o?.CODELIE)
            .filter((c: any) => c);
        Demand.OPEREL1 = codesLiees[0] ?? "";
        Demand.OPEREL2 = codesLiees[1] ?? "";
        Demand.OPEREL3 = codesLiees[2] ?? "";
        Demand.OPEREL4 = codesLiees[3] ?? "";
        Demand.OPEREL5 = codesLiees[4] ?? "";
        delete (Demand as any).OPERELIES;
        Demand.CODUTI = Perss.coduti
        Demand.DATCRE = formatDate(Perss.datjour)
        Demand.DATMOD = formatDate(Perss.datjour)
        Demand.LIBELL = form.getFieldValue("lib_CODOPE")

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Création d'un Code Operation",
                text: "Voulez-vous Créer le Code Operation : " + form.getFieldValue("lib_CODOPE"),
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)

                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateOperat,
                        headers: {
                            'CypherOperat': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                let code = res.Result
                                console.log(Demand)

                                if (res.StatutCode == 200) {

                                    if (code == 'Existe') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code existe déja svp choisissez un autre", icon: "warning" })
                                    } else {
                                        saveChaine(Demand.CODOPE)
                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "modif") {
            SweetAlert.fire({
                title: "Mise à Jour d'un Code Operation",
                text: "Voulez-vous Mettre à jour le  Code Operation : " + form.getFieldValue("lib_CODOPE"),
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateOperat,
                        headers: {
                            'CypherOperat': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    if (code == 'INCONNU') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                    } else {
                                        saveChaine(Demand.CODOPE)
                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }
                                    // setIsSubmit(false)
                                    // HandleAnnul()
                                    // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "supp") {

            SweetAlert.fire({
                title: "Suppression d'un Code Operation",
                text: "Voulez-vous Supprimer le Code Operation :" + form.getFieldValue("lib_CODOPE"),
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand.CODOPE));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.DeleteOperat,
                        headers: {
                            'CypherOperat': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    if (code == 'INCONNU') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                    } else {
                                        axios.request({ method: 'delete', url: OpeApi.DeleteChaine, headers: { 'CODOPE': Demand.CODOPE, 'Authorization': authHeader() } }).catch(() => { });
                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }
                                    // setIsSubmit(false)
                                    // HandleAnnul()
                                    // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> Interêt et Commission : {window.location.pathname.toUpperCase()} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default Operation;